import { instance, instanceWithAuth } from '@/api/index';

function loginUser(param) {
    return instance.post("/auth/login", param);
}

function refreshUser(param) {
    return instance.get("/auth/refresh", {params: param});
}

function listLogin(param) {
    return instance.post("/auth/list-login", param);
}

export { loginUser, refreshUser, listLogin };